import { PayoutStructureType, Prisma } from '@repo/database/src/types';

export interface CreatePayoutStructureDto {
  name: string;
  description?: string;
  type: PayoutStructureType;
}

// Create a type based on Prisma's TournamentPayoutBracket model
export type CreatePayoutBracketDto = Omit<Prisma.TournamentPayoutBracketUncheckedCreateInput, 'id' | 'ticketTemplate'>;

// Update DTO also based on the same model
export type UpdatePayoutBracketDto = Partial<Omit<CreatePayoutBracketDto, 'payoutStructureId'>>;

export interface TournamentPayoutStructureDto {
  id: string;
  name: string;
  description?: string;
  type: PayoutStructureType;
}
